import { ReactNode, useState } from 'react';
import { useAppStore } from '@/stores';
import { Typography, IconButton, Box } from '@mui/material';
import { ArrowLeft, Container, FlexWrapper, MenuToggler } from '@/components';
import SearchInput from '../search-input';
import SideMenu from './side-menu';
import { HeaderWrapper } from './header.styled';
import { useNavigate } from 'react-router';

export interface IHeaderProps {
  MenuTogglerType: INavButton;
  withSearch?: boolean;
  title?: string;
  subTitle? : string;
  children?: ReactNode | ReactNode[];
  handleSearch?: (searchVal: string) => void;
  handleArrowClick?: () => void;
  searchPlaceholderText?: string;
}
export enum  INavButton {
  'toggleMenu', 'goBack', 'none'
}

const Header = ({
  MenuTogglerType,
  withSearch = false,
  title,
  subTitle,
  children,
  handleSearch,
  handleArrowClick,
  searchPlaceholderText,
}: IHeaderProps) => {
  const navigate = useNavigate();
  const [isDrawerOpen, setIsDrawerOpen] = useState<boolean>(false);
  const { currentUser } = useAppStore();

  return (
    <HeaderWrapper>
      <Container>
        <FlexWrapper alignItems='center' justifyContent='space-between'>
          {MenuTogglerType!== INavButton.none && <IconButton
            color='primary'
            aria-label={MenuTogglerType.toString()}
            component='span'
            onClick={() => {
              if (MenuTogglerType === INavButton.toggleMenu) {
                setIsDrawerOpen(true);
              } else {
                if (handleArrowClick) {
                  handleArrowClick?.();
                } else {
                  navigate(-1);
                }
              }
            }}
          >
            {MenuTogglerType === INavButton.toggleMenu ? <MenuToggler /> :
             MenuTogglerType === INavButton.goBack ? <ArrowLeft />:<></>}
          </IconButton>}

          <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <Typography
              component='h1'
              variant='h6'
            >
              <Box
                component='span'
                sx={{
                  transform: `translateX(-${MenuTogglerType == INavButton.none ?
                    0 : MenuTogglerType == INavButton.toggleMenu ? 20 : 13}px)`,
                  display: 'inline-block',
                }}
              >
                {title}
              </Box>
              
            </Typography>
            {subTitle ?<Typography
              component='h6'
              variant='h6'
            >
              <Box
                component='span'
                sx={{
                  transform: `translateX(-${MenuTogglerType ? 10 : 10}px)`,
                  display: 'inline-block',
                }}
              >
                {subTitle}
              </Box>
              
            </Typography>:<></>}
          </Box>
        </FlexWrapper>
        {withSearch && (
          <Box sx={{ my: '15px' }}>
            <SearchInput
              handleSearch={handleSearch}
              placeHolder={searchPlaceholderText}
            />
          </Box>
        )}

        {children}
      </Container>
      <SideMenu
        userName={currentUser?.user?.name}
        userEmail={currentUser?.user?.email}
        isOpen={isDrawerOpen}
        onClose={() => setIsDrawerOpen(false)}
      />
    </HeaderWrapper>
  );
};

export default Header;
